import React, { useState, MouseEvent, useEffect } from 'react';
import {
  Button,
  FormControlLabel,
  Paper,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  IconButton,
  Typography,
  Checkbox,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import userProfile from '../../../../assets/images/userProfile.svg';
import audiLogDate from '../../../../assets/images/AudiLogDate.svg';
import audiLogUser from '../../../../assets/images/AudiLogUser.svg';
import audiLogEvent from '../../../../assets/images/AudiLogEvent.svg';
import { ReactComponent as SearchIcon } from '../../../../assets/images/Search.svg';
import PaginationComponent from '../../../../components/Pagination';
import createAxiosInstance from '../../../../api';
import emptyFolter from '../../../../assets/images/empty-folder 2.svg';
import { closeBlackIcon } from '../../../../assets/images';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { useSelector, useDispatch } from 'react-redux';
import { setAllUserListAction } from '../../../../stores/actionTypes/userActions';
import { setGlobalAuditlogListAction } from '../../../../stores/actionTypes/auditlogActions';

const AudiLog = () => {
  interface UserDataList {
    userID: string;
    userName: string;
    firstName: string;
    lastName: string;
    avatar: string;
  }

  const EventDatas: string[] = [
    'Create Role',
    'Login Event',
    'Reset Event',
    'Logout Event',
  ];

  // const date = [
  //   { name: 'Today', id: 1 },
  //   { name: 'Yesterday', id: 2 },
  //   { name: 'Last Week', id: 3 },
  //   { name: 'Last 15 Days', id: 4 },
  //   { name: 'Last Month', id: 5 },
  // ];
  const { allUsers } = useSelector((state: any) => state.user);
  const { globalauditlogList } = useSelector((state: any) => state.auditlog);
  const dispatch = useDispatch();

  const calculateTotalPages = (
    totalItems: number,
    rowsPerPage: number,
  ): number => {
    return Math.ceil(totalItems / rowsPerPage);
  };

  interface Filter {
    roleIDs: string[];
  }

  interface Role {
    userID?: string;
    event?: string;
    eventDescription?: string;
    eventTime?: string;
    avatar?: string;
    userName?: string;
  }

  const axiosInstance = createAxiosInstance();
  const [auditdata, setAuditdata] = useState<Role[]>([]);
  const [roleerror, setroleerror] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedData, setSelectedData] = useState<string[]>([]);
  const [selectedDate, setSelectedDate] = useState<string[]>(['Today']);
  const [userAnchorEl, setUserAnchorEl] = useState<null | HTMLElement>(null);
  const [dateAnchorEl, setDateAnchorEl] = useState<null | HTMLElement>(null);
  const [eventAnchorEl, setEventAnchorEl] = useState<null | HTMLElement>(null);
  const [filteredData, setFilteredData] = useState<UserDataList[]>([]);
  const [selectedusername, setSelectedusername] = useState<string[]>([]);
  const [userData, setUserdata] = useState<any[]>([]);
  const [eventNameQuery, setEventNameQuery] = useState<string>('');
  const [filteredEvent, setFilteredEvent] = useState<string[]>(EventDatas);
  const [filterPayload, setFilterPayload] = useState<null | any>(null);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    filterPayload
      ? fetchFilterDate(filterPayload, page, rowsPerPage)
      : getAuditData(page, rowsPerPage, eventNameQuery);
  };
  auditdata.forEach((user) => {
    console.log(user.eventDescription);
  });

  const startToday = new Date();
  startToday.setHours(0, 0, 0, 0);

  const [selectionRange, setSelectionRange] = useState({
    startDate: startToday,
    endDate: new Date(),
    key: 'selection',
  });

  const handleSelect = (ranges: any) => {
    setSelectionRange(ranges.selection);
    setCurrentPage(1);
  };
  const handleRowsPerPageChange = (value: number) => {
    filterPayload
      ? fetchFilterDate(filterPayload, currentPage - 1, value)
      : getAuditData(currentPage - 1, value);
    setRowsPerPage(value);
    setCurrentPage(1);
  };

  useEffect(() => {
    // Define the initial payload object
    const payload = {
      from: selectionRange.startDate.toISOString(),
      to: selectionRange.endDate.toISOString(),
    };

    // // Determine the 'from' date based on the selectedDate
    // if (selectedDate.includes('Last Month')) {
    //   // Calculate last month's date
    //   const lastMonthDate = new Date();
    //   lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
    //   payload.from = lastMonthDate.toISOString();
    // } else if (selectedDate.includes('Last 15 Days')) {
    //   // Calculate 15 days ago date
    //   const fifteenDaysAgoDate = new Date();
    //   fifteenDaysAgoDate.setDate(fifteenDaysAgoDate.getDate() - 15);
    //   payload.from = fifteenDaysAgoDate.toISOString();
    // } else if (selectedDate.includes('Last Week')) {
    //   // Calculate last week's date
    //   const lastWeekDate = new Date();
    //   lastWeekDate.setDate(lastWeekDate.getDate() - 7);
    //   payload.from = lastWeekDate.toISOString();
    // } else if (selectedDate.includes('Yesterday')) {
    //   // Calculate yesterday's date
    //   const yesterdayDate = new Date();
    //   yesterdayDate.setDate(yesterdayDate.getDate() - 1);
    //   payload.from = yesterdayDate.toISOString();
    // } else if (selectedDate.includes('Today')) {
    //   // Set 'from' to today's date with starting time
    //   const todayDate = new Date();
    //   todayDate.setHours(0, 0, 0, 0);
    //   payload.from = todayDate.toISOString();
    // }
    if (
      // selectedDate?.length > 0 ||
      selectionRange ||
      selectedusername.length > 0 ||
      selectedData.length > 0
    ) {
      fetchFilterDate(payload);
      setFilterPayload(payload);
    } else {
      setFilterPayload(null);
    }
  }, [selectedDate, selectedData, selectedusername, selectionRange]);

  const fetchFilterDate = async (
    payload?: any,
    pagenumber?: number,
    row_perpage?: number,
  ) => {
    await axiosInstance
      .post('/globalAuditList', {
        from: payload.from ? payload.from : null,
        to: payload.from ? payload.to : null,
        eventNames: selectedData ? selectedData : '',
        userIDs: selectedusername,
        limit: row_perpage ? row_perpage : rowsPerPage,
        offset: pagenumber
          ? (pagenumber - 1) * rowsPerPage
          : (currentPage - 1) * rowsPerPage,
      })
      .then((response) => {
        setAuditdata(response.data.data);
        dispatch(setGlobalAuditlogListAction(response?.data?.data));

        const uniqueEventNames = [
          ...new Set(response.data.data.map((item: any) => item.event)),
        ];

        // setFilteredData(uniqueEventNames);
        // setFilteredData(['Login Event', 'Create Role', 'Reset Event']);

        setroleerror(false);

        setTotalPages(
          Math.ceil(
            response.data.count / (row_perpage ? row_perpage : rowsPerPage),
          ),
        );
      })
      .catch((error) => {
        setAuditdata([]);
        setroleerror(true);
      });
  };

  const handleChange = (username: any): void => {
    if (username) {
      if (selectedData.includes(username)) {
        const updatedData = selectedData.filter(
          (item: any) => item !== username,
        );
        setSelectedData(updatedData);
      } else {
        const adddata = [...selectedData, username];
        const uniqueEventNames = [...new Set(adddata)];
        setSelectedData(uniqueEventNames);
      }
    } else {
      return;
    }
    setCurrentPage(1);
  };

  const handleuser = (userId: string): void => {
    if (selectedusername.includes(userId)) {
      const updateUser = selectedusername?.filter((user) => user !== userId);
      setSelectedusername(updateUser);
    } else {
      setSelectedusername([...selectedusername, userId]);
    }
    setCurrentPage(1);
  };

  const handledate = (dateId: number | string): void => {
    if (typeof dateId === 'string') {
      if (selectedDate.includes(dateId)) {
        setSelectedDate([]);
      } else {
        setSelectedDate([dateId]);
      }
    }
    setCurrentPage(1);
  };

  const currentDummyData = [
    {
      profile: userProfile,
      name: 'Gretchen Stanton',
      event: 'Logged In',
      updated: '11:23:41',
    },
  ];

  const handleUserClick = (event: MouseEvent<HTMLElement>): void => {
    setUserAnchorEl(event.currentTarget);
  };

  const handleDateClick = (event: MouseEvent<HTMLElement>): void => {
    setDateAnchorEl(event.currentTarget);
  };

  const handleEventClick = (event: MouseEvent<HTMLElement>): void => {
    setEventAnchorEl(event.currentTarget);
  };

  const handleUserClose = () => {
    setUserAnchorEl(null);
  };
  const handleDateClose = () => {
    setDateAnchorEl(null);
  };
  const handleEventClose = () => {
    setEventAnchorEl(null);
  };

  const handleUserSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query: string = event.target.value.toLowerCase();
    const filtered: UserDataList[] = userData?.filter((user) =>
      `${user.firstName + user.lastName}`.toLowerCase().includes(query),
    );
    setFilteredData(filtered);
  };

  const handleEventNameSearchChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const query = event.target.value;
    setEventNameQuery(query);
    const filtered = EventDatas.filter((item) =>
      item.toLowerCase().includes(query.toLowerCase()),
    );
    setFilteredEvent(filtered);
  };
  function formatDate(isoDate: any) {
    const months = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC',
    ];

    const date = new Date(isoDate);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  function formatTime(isoDate: any): string {
    const date = new Date(isoDate);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  }
  const getAuditData = async (
    pagenumber?: number,
    row_perpage?: number,
    search: unknown = '',
    filters: Filter[] | undefined = [],
    // sort: Sort | undefined = { orderBy: 'name', order: 'asc' },
  ) => {
    const setfilter = filters?.length > 0 ? { roleIDs: filters } : {};

    await axiosInstance
      .post('/globalAuditList', {
        search: search,
        // sort: sort,
        filters: setfilter,
        limit: row_perpage ? row_perpage : rowsPerPage,
        offset: pagenumber
          ? (pagenumber - 1) * rowsPerPage
          : (currentPage - 1) * rowsPerPage,
      })
      .then((response) => {
        setAuditdata(response.data.data);
        dispatch(setGlobalAuditlogListAction(response?.data?.data));
        setTotalPages(
          Math.ceil(
            response.data.count / (row_perpage ? row_perpage : rowsPerPage),
          ),
        );
        setroleerror(false);
      })
      .catch(() => {
        setAuditdata([]);
        setroleerror(true);
      });
  };

  const getUserData = async () => {
    await axiosInstance
      .post('/listUser', {})
      .then((response) => {
        if (response?.data?.data) {
          dispatch(setAllUserListAction(response?.data?.data));
          setUserdata(response?.data?.data);
          setFilteredData(response?.data?.data);
        }
      })
      .catch(() => {
        setUserdata([]);
        setFilteredData([]);
      });
  };

  useEffect(() => {
    if (allUsers?.length > 0) {
      setUserdata(allUsers);
      setFilteredData(allUsers);
    } else {
      getUserData();
    }
  }, []);

  useEffect(() => {
    if (!filterPayload && !(selectedDate?.length > 0)) {
      getAuditData();
    }
  }, [filterPayload]);

  const findname = (uid: string) => {
    const selectName = userData?.filter((user) => user.userID === uid);
    return selectName;
  };
  const userOpen = Boolean(userAnchorEl);
  const userId = userOpen ? 'simple-popover' : undefined;
  const dateOpen = Boolean(dateAnchorEl);
  const dateId = dateOpen ? 'simple-popover' : undefined;
  const eventOpen = Boolean(eventAnchorEl);
  const eventId = eventOpen ? 'simple-popover' : undefined;

  return (
    <>
      <div className="content  global_audilog user_management">
        <div className="global_audilog_header">
          <Button
            className="global_audilog_date-btn global_buttons"
            aria-describedby={dateId}
            onClick={handleDateClick}
          >
            <img src={audiLogDate} width={24} alt="date img" />
            <Typography>Date</Typography>
          </Button>
          <div>
            <Button
              className="global_audilog_user_name-btn global_buttons"
              aria-describedby={userId}
              onClick={handleUserClick}
            >
              <img src={audiLogUser} width={24} alt="avater img" />
              <Typography>User Name</Typography>
            </Button>
            <div>
              {/* <div>
              {findname(selectedusername)?.map((user, index) => (
                <div key={index} className="filterlist">
                  <p>{user?.firstName +""+user?.lastName}</p>
                  <Button onClick={() => handleuser(user?.id)}>
                    <img src={closeBlackIcon} alt="Delete Icon" width={13} />
                  </Button>
                </div>
              ))}
          </div> */}
            </div>
          </div>

          <Button
            className={
              selectedData?.length > 0
                ? 'global_audilog_event_name-btn global_buttons global_buttons-active'
                : 'global_audilog_event_name-btn global_buttons'
            }
            aria-describedby={eventId}
            onClick={handleEventClick}
          >
            <img src={audiLogEvent} width={24} alt="event img" />
            <Typography>Event Name</Typography>
            <div className="global_buttons-filtercount">
              <p>{selectedData?.length}</p>
            </div>
          </Button>
        </div>
        <div>
          {selectedData.map((event, index) => (
            <div key={index} className="filterlist">
              <p>{event}</p>
              <Button onClick={() => handleChange(event)}>
                <img src={closeBlackIcon} alt="Delete Icon" width={13} />
              </Button>
            </div>
          ))}
        </div>

        <TableContainer
          className="global_audilog_table-container"
          component={Paper}
        >
          <Table>
            <TableHead className="global_audilog_table-heading">
              <TableRow>
                <TableCell className="global_audilog_event-name">
                  <Typography>Event Name</Typography>
                </TableCell>
                <TableCell className="global_audilog_user-name">
                  <Typography>User Name</Typography>
                </TableCell>
                <TableCell className="global_audilog_update">
                  <Typography>Event Description</Typography>
                </TableCell>
                <TableCell className="global_audilog_update">
                  <Typography>Last Updated</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {auditdata?.map((user, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Typography>{user?.event}</Typography>
                  </TableCell>
                  <TableCell>
                    <div className="global_audilog_name-data">
                      <img
                        src={user?.avatar ? user?.avatar : userProfile}
                        width={24}
                        alt="User Profile"
                      />{' '}
                      <Typography>
                        {user?.userName ? user?.userName : ''}
                      </Typography>
                    </div>
                  </TableCell>
                  <TableCell>
                    <Typography>
                      {user?.eventDescription && (
                        <>
                          {user.eventDescription
                            .split(',')
                            .map((part, index) => (
                              <div key={index}>
                                {part.split('.').map((subPart, subIndex) => (
                                  <div key={subIndex}>{subPart}</div>
                                ))}
                              </div>
                            ))}
                        </>
                      )}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>
                      {formatDate(user?.eventTime) +
                        '  ' +
                        formatTime(user.eventTime)}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {!(auditdata?.length > 0) && (
          <div className="global_audilog-nodata">
            <img src={emptyFolter} alt="nodata" width="120" height="120" />
            <h3>No Record Found!</h3>
          </div>
        )}

        {auditdata?.length > 0 && (
          <PaginationComponent
            rowsPerPageOptions={[5, 10, 20, 30]}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            totalPages={totalPages}
          />
        )}

        <Popover
          className="popover-audit"
          id={dateId}
          open={dateOpen}
          anchorEl={dateAnchorEl}
          onClose={handleDateClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          {/* <div className="date-popover">
            {date.map((user, index) => {
              return (
                <div
                  key={index}
                  className={
                    selectedDate.includes(user.name)
                      ? 'role-popover-checkbox role-popover-checkbox_active'
                      : 'role-popover-checkbox'
                  }
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedDate.includes(user.name)}
                        onChange={() => {
                          handledate(user.name);
                        }}
                        sx={{
                          color: '#667085', // Change border color
                          '&.Mui-checked': {
                            color: '#00B3F3', // Change checked color
                          },
                        }}
                      />
                    }
                    label={user.name}
                  />
                </div>
              );
            })}
          </div> */}
          <div>
            <DateRangePicker
              ranges={[selectionRange]}
              onChange={handleSelect}
            />
          </div>
        </Popover>

        <Popover
          className="popover-audit"
          id={userId}
          open={userOpen}
          anchorEl={userAnchorEl}
          onClose={handleUserClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <div className="user_name-popover">
            <div className="user_name-popover-search">
              <TextField
                className="user_name-popover-search_input search-input"
                variant="outlined"
                placeholder="Search user names here"
                fullWidth
                InputProps={{
                  startAdornment: <SearchIcon className="search_icon" />,
                }}
                onChange={handleUserSearch}
              />
            </div>
            {filteredData.map((user, index) => (
              <Button
                key={index}
                onClick={() => {
                  handleuser(user.userID);
                }}
                className={
                  selectedusername.includes(user.userID)
                    ? 'global_audilog_user user_checked'
                    : 'global_audilog_user'
                }
              >
                <div className="global_audilog_user_profile">
                  <img
                    src={user?.avatar ? user?.avatar : userProfile}
                    width={24}
                    alt="User Profile"
                  />{' '}
                  <p>{`${user?.firstName} ${user?.lastName}`}</p>
                </div>
                {selectedusername?.includes(user.userID) && (
                  <IconButton className="iconButton">
                    <DoneIcon className="doneIcon" />
                  </IconButton>
                )}
              </Button>
            ))}
          </div>
        </Popover>

        <Popover
          className="popover-audit"
          id={eventId}
          open={eventOpen}
          anchorEl={eventAnchorEl}
          onClose={handleEventClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <div className="user_name-popover">
            <div className="user_name-popover-search">
              <TextField
                className="user_name-popover-search_input search-input"
                variant="outlined"
                placeholder="Search event names here"
                fullWidth
                InputProps={{
                  startAdornment: <SearchIcon className="search_icon" />,
                }}
                value={eventNameQuery}
                onChange={handleEventNameSearchChange}
              />
            </div>
            <div className="event-popover">
              {filteredEvent.map((user, index) => {
                return (
                  <div
                    key={index}
                    className={
                      selectedData.includes(user)
                        ? 'role-popover-checkbox role-popover-checkbox_active'
                        : 'role-popover-checkbox'
                    }
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedData.includes(user)}
                          onChange={() => {
                            handleChange(user);
                          }}
                        />
                      }
                      label={user}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </Popover>
      </div>
    </>
  );
};

export default AudiLog;
